/*###########################################################################
// Slider handle
//#########################################################################*/

import { throttle } from "@js/utilities/_throttleDebounce"

import Swiper from 'swiper'

const sliderHandle = {
  config: {
    sliderHandle: '.sliderHandle'
  },

  elements: {},

  init() {
    const self = this

    self.elements.sliderHandle = document.querySelectorAll(self.config.sliderHandle)

    if (self.elements.sliderHandle !== null) {
      for (let i = 0; i < self.elements.sliderHandle.length; i++) {
        const sliderHandle = self.elements.sliderHandle[i]

        self.handleSliderHandle(sliderHandle)
      }
    }

		window.addEventListener('modalOpen', (e) => {
			const modal = e.detail.modal

			const sliderHandle = modal.querySelector(self.config.sliderHandle)

			if (sliderHandle !== null) {
				self.handleSliderHandle(sliderHandle)
			}
		})
  },

  handleSliderHandle(slider) {
    const self = this

		const controls = slider.parentNode.querySelector('.slider__controls')
    const prevBtn = controls.querySelector('.slider__control--prev')
    const nextBtn = controls.querySelector('.slider__control--next')

    const swiper = new Swiper(slider, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      loop: false,
			breakpoints: {
				640: {
					spaceBetween: 16,
					slidesPerView: 1.275
				},
			}
    })

    if (swiper.isBeginning) {
      prevBtn.classList.add('is-disabled')
    }

    swiper.on('slideChange', function() {
      if (swiper.isBeginning) {
        prevBtn.classList.add('is-disabled')
      }

      if (swiper.isEnd) {
        nextBtn.classList.add('is-disabled')
      }
		})

    swiper.on('fromEdge', function() {
      prevBtn.classList.remove('is-disabled')
      nextBtn.classList.remove('is-disabled')
    })

    swiper.on('reachBeginning', function () {
      if (swiper.isBeginning) {
        prevBtn.classList.add('is-disabled')
      }
    })

    swiper.on('reachEnd', function () {
      if (swiper.isEnd) {
        nextBtn.classList.add('is-disabled')
      }
    })

    prevBtn.addEventListener('click', function (e) {
      swiper.slidePrev()
    })

    nextBtn.addEventListener('click', function (e) {
      swiper.slideNext()
    })

		setTimeout(() => {
			self.controlsVisibleCheck(slider, swiper, controls)

			window.addEventListener('resize', throttle(function () {
				self.controlsVisibleCheck(slider, swiper, controls)

				nextBtn.classList.remove('is-disabled')

				if (swiper.isEnd) {
					nextBtn.classList.add('is-disabled')
				}
			}, 250))
		}, 500)
  },

	controlsVisibleCheck(slider, swiper, controls) {
    const totalSlides = swiper.slides.length
    const slidesPerView = swiper.params.slidesPerView

    if (totalSlides <= slidesPerView) {
      controls.classList.add('slider__controls--hidden')
      swiper.disable()
    } else {
      controls.classList.remove('slider__controls--hidden')
      swiper.enable()
    }
  },
}

initComponent(() => {
	sliderHandle.init()
})
